import React, { useEffect, useState } from 'react';
import { Modal, Grid, TextField, Snackbar } from '@material-ui/core';
import { Form, Formik } from 'formik';
import { Input } from '../../../components/forms';
import Button from '../../../components/common/Button';
import * as Yup from 'yup';
import InputWrapper from '../../../components/forms/Input/inputWrapper';
import CloseIcon from '@material-ui/icons/Close';
import AnnouncementApi from '../announcement-api';
import RescheduleErrorModal from './rescechule-error';
import { Autocomplete } from '@material-ui/lab';
import RescheduleSummary from './reschedule-summary';

import Select from '../../../components/forms/Select';
import { AVAILABLE_HOURS } from '../../../utils/dates';
import Spinner from '../../../components/common/Spinner';
import MuiAlert from '@material-ui/lab/Alert';

const AnnouncementModal = ({
  isOpen,
  onClose,
  sessionData,
  onRescheduleSuccess,
}) => {
  const Alert = (props) => <MuiAlert elevation={6} variant="filled" {...props} />;
  const [showSummary, setShowSummary] = useState(false);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [formValues, setFormValues] = useState({
    idMentor: sessionData?.mentor?.id ?? '',
    idMentee: sessionData?.mentee?.id ?? '',
    title: '',
    description: '',
    reason: '',
    available_date: '',
    hour: '',
    mentee: sessionData?.mentee?.name ?? '',
    mentor: sessionData?.mentor?.name ?? '',
    clientId: sessionData?.clientId ?? sessionData?.client?.id ?? null,
  });

  useEffect(() => {
    if (!sessionData) {
      return;
    }
    setFormValues((prev) => ({
      ...prev,
      idMentor: sessionData?.mentor?.id ?? prev.idMentor,
      idMentee: sessionData?.mentee?.id ?? prev.idMentee,
      mentor: sessionData?.mentor?.name ?? prev.mentor,
      mentee: sessionData?.mentee?.name ?? prev.mentee,
      clientId: sessionData?.clientId ?? sessionData?.client?.id ?? prev.clientId,
    }));
  }, [sessionData]);

  const handleCloseSnackbar = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  async function onSubmit(values) {
    try {
      setIsSubmitting(true);
      setShowErrorModal(false);
      setSnackbarState((prev) => ({ ...prev, open: false }));

      const { available_date, hour, ...restSession } = values;
      const time = hour > 9 ? `${hour}:00` : `0${hour}:00`;

      const calendar = { available_date, hour: time };
      const clientId =
        sessionData?.clientId ?? values?.clientId ?? sessionData?.client?.id ?? null;
      const response = await AnnouncementApi.rescheduleMeeting(sessionData.id, {
        ...restSession,
        clientId,
        calendar,
      });

      setSnackbarState({
        open: true,
        message: 'La reunión fue reagendada correctamente.',
        severity: 'success',
      });

      onRescheduleSuccess?.({
        sessionId: sessionData.id,
        calendar,
        formValues: { ...restSession, clientId, available_date, hour },
        response,
      });

      setFormValues(response);
      setShowSummary(true);
    } catch (error) {
      setSnackbarState({
        open: true,
        message:
          error?.data?.message ||
          'No fue posible reagendar la reunión. Intenta nuevamente.',
        severity: 'error',
      });
      setErrorData(error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div>
      <Modal
        title="Reagendar reunión"
        className="custom_modal"
        open={isOpen}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div
          className="reschedule-session"
          style={{ position: 'relative' }}
        >
          {isSubmitting && (
            <Spinner
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: 'rgba(255, 255, 255, 0.6)',
                zIndex: 10,
                pointerEvents: 'all',
              }}
            />
          )}
          <div className="modal__title-container">
            <h3 className="title">
              {showErrorModal ? 'Horario no disponible' : 'Reagendar'}
            </h3>
            <span className="close-modal" onClick={onClose}>
              <CloseIcon className="close__icon" />
            </span>
          </div>
          {showSummary ? (
            <RescheduleSummary
              formValues={formValues}
              onClose={onClose}
              sessionId={sessionData.id}
            />
          ) : showErrorModal ? (
            <RescheduleErrorModal
              errorData={errorData}
              formValues={formValues}
              onBack={() => setShowErrorModal(false)}
            />
          ) : (
            <>
              <p className="description">
                Ingresa los datos mencionados para agregar un nuevo
                participante a la convocatoria
              </p>
              <Formik
                enableReinitialize
                initialValues={formValues}
                validationSchema={Yup.object({
                  idMentor: Yup.string().required('Se requiere un Mentor'),
                  mentee: Yup.string().required('Se requiere un Mentee'),
                  title: Yup.string().required('Se requiere un asunto'),
                  description: Yup.string().required(
                    'Se requiere una descripción'
                  ),
                  reason: Yup.string(),
                  available_date: Yup.string().required(
                    'Se requiere una Fecha para reagendar'
                  ),
                  hour: Yup.string().required(
                    'Se requiere una hora para reagendar'
                  ),
                })}
                onSubmit={(values) => {
                  onSubmit({
                    ...values,
                    idMentor: sessionData?.mentor?.id,
                    idMentee: sessionData?.mentee?.id,
                    mentor: sessionData?.mentor?.name,
                    mentee: sessionData?.mentee?.name,
                  });
                }}
              >
                {(props) => (
                  <Form>
                    <div className="reschedule-form">
                      <div className="reschedule-row">
                        <InputWrapper
                          name="idMentor"
                          label="Mentor"
                          id="idMentor"
                        >
                          <input type="hidden" name="mentorId" />
                          <Input
                            disabled
                            placeholder="Mentor"
                            name="mentor"
                            type="select"
                            value={sessionData.mentor.name}
                          />
                        </InputWrapper>
                        <InputWrapper name="mentee" label="Mentee" id="mentee">
                          <input type="hidden" name="mentee" />
                          <Input
                            disabled
                            placeholder="Mentee"
                            name="mentee"
                            type="select"
                            value={sessionData.mentee.name}
                          />
                        </InputWrapper>
                      </div>

                      <div className="reschedule-row full-width">
                        <InputWrapper
                          name="title"
                          label="Asunto"
                          id="title"
                          variant="full"
                        >
                          <Input
                            placeholder="Asunto"
                            name="title"
                            type="select"
                            max={500}
                            fullWidth
                          />
                        </InputWrapper>
                      </div>

                      <div className="reschedule-row full-width">
                        <InputWrapper
                          name="description"
                          label="Motivo Reagendación"
                          id="description"
                        >
                          <Input
                            placeholder="Descripcion"
                            name="description"
                            type="textarea"
                            max={500}
                            fullWidth
                            showCounter
                          />
                        </InputWrapper>
                      </div>

                      <div className="reschedule-row">
                        <InputWrapper
                          name="available_date"
                          label="Fecha de inicio"
                          id="available_date"
                        >
                          <Input label="" type="date" name="available_date" />
                        </InputWrapper>

                        <InputWrapper id="hour" name="hour">
                          <Select
                            name="hour"
                            placeholder="Hora"
                            label="Hora"
                            type="select"
                            options={[]}
                            advancedOptions={AVAILABLE_HOURS}
                          />
                        </InputWrapper>
                      </div>
                    </div>
                    <div className="info__button">
                      <div className="save-area">
                        <Grid container justify="space-around">
                          <Grid item xs={5}>
                            <Button widthFull secondary onClick={onClose}>
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item xs={5}>
                        <Button
                          widthFull
                          type="submit"
                          loading={isSubmitting}
                          disabled={isSubmitting}
                        >
                          Reagendar
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </div>
      </Modal>
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarState.severity}>
          {snackbarState.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AnnouncementModal;

